import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Label = styled.b`
  color: ${props => props.theme.carvana.blue.dark};
  display: inline-block;
`;

const Text = styled.p`
  color: ${props => props.theme.carvana.gray.dark};
`;

const DeliveryMethodAddress = props => {
  const {
    schedule: {
      address: { addressLine1, addressLine2, city, state, zipCode },
      deliveryPreference
    }
  } = props;
  const isDelivery = deliveryPreference?.toLowerCase()?.includes('delivery');
  const deliveryType = isDelivery ? 'Delivery' : 'Pick-up';

  return (
    <>
      <Label>{deliveryType} Address</Label>
      <Text>{addressLine1}</Text>
      {addressLine2 && <Text>{addressLine2}</Text>}
      <Text>{`${city} ${state}, ${zipCode}`}</Text>
    </>
  );
};

DeliveryMethodAddress.propTypes = {
  schedule: PropTypes.shape({}).isRequired,
};

DeliveryMethodAddress.defaultProps = {};

export default DeliveryMethodAddress;
